const useFilename = (src: string) => {
  const filename = src.split('/').at(-1);
  return filename;
};

export default useFilename;
